import { SearchFilters, DEFAULT_SEARCH_FILTERS } from '../types/searchFilters';

function joinArray(value: string | string[] | undefined): string {
  if (Array.isArray(value)) return value.filter(Boolean).join(',');
  if (!value) return '';
  return String(value);
}

function normalizeZone(zona: string): string {
  return typeof zona === 'string' ? zona.replace(/\s+de\s+.+$/, '').trim() : '';
}

function joinQty(value: string[] | undefined): string {
  if (!value?.length) return '';
  return value.map((v) => String(v).replace('+', '')).join(',');
}

function rangeOrEmpty(
  min: number | undefined,
  max: number | undefined,
  defaultMin: number,
  defaultMax: number,
): { min: string; max: string } {
  const minVal = min ?? defaultMin;
  const maxVal = max ?? defaultMax;
  if (minVal === defaultMin && maxVal === defaultMax) {
    return { min: '', max: '' };
  }
  return { min: String(minVal), max: String(maxVal) };
}

export type BuildListBuildingOptions = {
  id_corretor?: string | number;
  no_address?: boolean;
  pagination?: string;
};

export function buildListBuildingParams(
  filters: Partial<SearchFilters>,
  options?: BuildListBuildingOptions,
): Record<string, string> {
  const isSale = filters.is_sale === '1' && filters.is_rent !== '1';
  const isRent = filters.is_rent === '1' && filters.is_sale !== '1';

  const sale = rangeOrEmpty(
    filters.min_sale_price,
    filters.max_sale_price,
    DEFAULT_SEARCH_FILTERS.min_sale_price,
    DEFAULT_SEARCH_FILTERS.max_sale_price,
  );
  const rent = rangeOrEmpty(
    filters.min_rent_price,
    filters.max_rent_price,
    DEFAULT_SEARCH_FILTERS.min_rent_price,
    DEFAULT_SEARCH_FILTERS.max_rent_price,
  );
  const taxas = rangeOrEmpty(
    filters.min_taxas,
    filters.max_taxas,
    DEFAULT_SEARCH_FILTERS.min_taxas,
    DEFAULT_SEARCH_FILTERS.max_taxas,
  );
  const area = rangeOrEmpty(
    filters.min_area,
    filters.max_area,
    DEFAULT_SEARCH_FILTERS.min_area,
    DEFAULT_SEARCH_FILTERS.max_area,
  );

  const raw: Record<string, string> = {
    portal: 'hub',
    query_search: filters.query_search?.toString() ?? '',
    is_sale: isSale ? '1' : '',
    is_rent: isRent ? '1' : '',
    is_launch: filters.is_launch === '1' ? '1' : '',
    min_sale_price: sale.min,
    max_sale_price: sale.max,
    min_rent_price: rent.min,
    max_rent_price: rent.max,
    min_taxas: taxas.min,
    max_taxas: taxas.max,
    min_area: area.min,
    max_area: area.max,
    is_mobiliado: filters.is_mobiliado?.toString() ?? '',
    address_street: filters.address_street?.toString() ?? '',
    address_city: joinArray(filters.address_city),
    address_district: joinArray(filters.address_district),
    address_zone: Array.isArray(filters.address_zone)
      ? filters.address_zone.map(normalizeZone).filter(Boolean).join(',')
      : joinArray(filters.address_zone),
    id_empreendimento: filters.id_empreendimento?.toString() ?? '',
    id_constructor: filters.id_constructor?.toString() ?? '',
    id_type: joinArray(filters.id_type),
    id_category: filters.id_category?.toString() ?? '',
    id_corretor: options?.id_corretor?.toString() ?? '',
    qtd_rooms: joinQty(filters.qtd_rooms),
    qtd_bathrooms: joinQty(filters.qtd_bathrooms),
    qtd_suite: joinQty(filters.qtd_suite),
    qtd_parking: joinQty(filters.qtd_parking),
    order_by: filters.order_by?.toString() ?? '0',
    order_type: filters.order_type?.toString() ?? 'desc',
    no_address: options?.no_address === false ? '' : '1',
  };

  if (options?.pagination) {
    raw.pagination = options.pagination;
  }

  return raw;
}
